import './melbournegroupchat/style';
import FormStructure from './melbournegroupchat/form_structure';

export default FormStructure;